module.exports = __webpack_public_path__ + "static/media/h8.766a46b5.png";